import gql from "graphql-tag";

export default gql`
  query userSession {
    viewer {
      sessionId
    }
  }
`;
